import { useState } from 'react'
import { updateProject } from '../api/client'
import type { Project } from '../types'

interface Props {
  project: Project
  onClose: () => void
  onChanged: () => void
}

/**
 * Édition d'un projet : son nom, l'outcome visé, et sa clôture.
 * Clôturer ne supprime rien — les actions déjà posées restent dans les listes.
 */
export default function ProjectSheet({ project, onClose, onChanged }: Props) {
  const [title, setTitle] = useState(project.title)
  const [outcome, setOutcome] = useState(project.outcome ?? '')
  const [status, setStatus] = useState<'active' | 'done'>(project.status === 'done' ? 'done' : 'active')
  const [err, setErr] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function save() {
    if (busy) return
    if (!title.trim()) {
      setErr('Le nom du projet ne peut pas être vide.')
      return
    }
    setBusy(true)
    try {
      await updateProject(project.id, { title: title.trim(), outcome: outcome.trim(), status })
      onClose()
      onChanged()
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="sheet" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="panel">
        <h3>Modifier le projet</h3>
        <div className="lbl">Nom</div>
        <input value={title} onChange={(e) => setTitle(e.target.value)} />
        <div className="lbl">Outcome — à quoi ressemble « terminé » ?</div>
        <textarea
          rows={2}
          value={outcome}
          onChange={(e) => setOutcome(e.target.value)}
          placeholder="ex. Roadtrip réservé et préparé"
        />
        <div className="lbl">Statut</div>
        <div className="chips">
          <button className={'chip' + (status === 'active' ? ' on' : '')} onClick={() => setStatus('active')}>
            actif
          </button>
          <button className={'chip' + (status === 'done' ? ' on' : '')} onClick={() => setStatus('done')}>
            clôturé
          </button>
        </div>
        {status === 'done' && project.status !== 'done' && (
          <div className="hint" style={{ marginTop: 10 }}>
            Le projet sort des listes actives. Ses actions déjà posées y restent.
          </div>
        )}
        {err && <div className="lerr">{err}</div>}
        <div className="actions">
          <button className="save" onClick={() => void save()}>
            Enregistrer
          </button>
          <button className="cancel" onClick={onClose}>
            Annuler
          </button>
        </div>
      </div>
    </div>
  )
}
